import {
  DataService,
  ModalService,
  NotificationService,
  Permission,
  registerBulkAction,
} from '@vendure/admin-ui/core';
import { gql } from 'graphql-tag';
import { of, switchMap } from 'rxjs';

const DELETE_ORDERS_MUTATION = gql`
  mutation DeleteOrders($orderIds: [ID!]!) {
    deleteOrdersById(orderIds: $orderIds) {
      success
      failed
      errors {
        id
        message
      }
    }
  }
`;

export const bulkDeleteOrdersAction = registerBulkAction({
  location: 'order-list',
  label: 'Delete Orders',
  icon: 'trash',
  requiresPermission: (userPermissions) =>
    userPermissions.includes(Permission.DeleteOrder),
  onClick: ({ injector, selection, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    const notificationService = injector.get(NotificationService);

    if (selection.length === 0) {
      return;
    }

    modalService
      .dialog({
        title: `Delete ${selection.length} order(s)`,
        body: `Are you sure you want to delete ${selection.length} order(s)? This action cannot be undone.`,
        buttons: [
          { type: 'secondary', label: 'Cancel' },
          { type: 'danger', label: 'Delete', returnValue: true },
        ],
      })
      .pipe(
        switchMap((value) => {
          if (value) {
            const orderIds = selection.map((order) => order.id);

            return dataService.mutate<{
              deleteOrdersById: {
                success: number;
                failed: number;
                errors: { id: string; message: string }[];
              };
            }>(DELETE_ORDERS_MUTATION, { orderIds });
          }
          return of(null);
        }),
      )
      .subscribe((result) => {
        if (result) {
          const { success, failed, errors } = result.deleteOrdersById;

          if (success > 0) {
            notificationService.success(
              `Successfully deleted ${success} order(s)`,
            );
          }

          if (failed > 0) {
            notificationService.error(
              `Failed to delete ${failed} order(s). ${errors.map((e) => `Order ${e.id}: ${e.message}`).join(', ')}`,
            );
          }

          hostComponent.refresh();
          clearSelection();
        }
      });
  },
});
